import { EntityModel } from '@/interfaces'
import {
  ALL_ITEMS_QUERY,
  CREATE_ITEM_MUTATION,
  DELETE_ITEM_MUTATION,
  FORCE_DELETE_ITEM_MUTATION,
  SINGLE_ITEM_QUERY,
  UPDATE_ITEM_MUTATION,
} from './graphql'
import mediaFileEntity from '@/entities/mediaFile/entity'
import itineraryMapMarkerEntity from '@/entities/itineraryMapMarker/entity'

const itineraryItemModel: EntityModel = {
  name: 'item',
  namePlural: 'items',
  uniqueName: 'itineraryItem',
  uniqueNamePlural: 'itineraryItems',
  path: 'travel/itinerary/item',
  baseUrl: '/travel/itinerary/items',
  translationPrefix: 'entities:itineraryItem.',
  getDisplayName: (values: any) => {
    return values.title
  },
  gql: {
    getAll: ALL_ITEMS_QUERY,
    getSingle: SINGLE_ITEM_QUERY,
    create: CREATE_ITEM_MUTATION,
    update: UPDATE_ITEM_MUTATION,
    delete: DELETE_ITEM_MUTATION,
    forceDelete: FORCE_DELETE_ITEM_MUTATION,
  },
  attributes: {
    duration: {
      name: 'duration',
      label: 'entities:itineraryItem.attributes.duration.label',
      type: 'value',
      dataType: 'number',
      defaultValue: 1,
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    title: {
      name: 'title',
      label: 'entities:itineraryItem.attributes.title.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    text: {
      name: 'text',
      label: 'entities:itineraryItem.attributes.text.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'wysiwyg',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    image: {
      name: 'image',
      label: 'entities:itineraryItem.attributes.image.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return mediaFileEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    mapMarkers: {
      name: 'mapMarkers',
      label: 'entities:itineraryItem.attributes.mapMarkers.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return itineraryMapMarkerEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default itineraryItemModel
